export default {
    businesses: [],
};
